/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import ActionToggle from './action-toggle';

export * from './action-toggle.props';

/**
 * Exporting the ActionToggle components.
 */
export { ActionToggle };
